import type { QuestionFilters } from './question-filters'
import type { useQuestionFilters } from './use-question-filters'
import { useTranslation } from 'react-i18next'
import { Input } from '~/components/ui/input'
import { tourAnchor } from '~/helpers/tour/anchors'
import { FilterSelect, TableToolbar } from '~/pages/backoffice/TableToolbar'

type Props = Pick<ReturnType<typeof useQuestionFilters>, 'filters' | 'set' | 'sessions' | 'groups' | 'modules'>

/** Le module analysé, puis les filtres de population et de période (#159). */
function QuestionFiltersBar({ filters, set, sessions, groups, modules }: Props) {
  const { t } = useTranslation()
  const text = (key: keyof QuestionFilters) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => set(key)(e.target.value)

  return (
    <div {...tourAnchor('questions.filters')}>
      <TableToolbar>
        <FilterSelect value={filters.sessionId} onChange={text('sessionId')} aria-label={t('common.sessions')}>
          <option value="">{t('common.allSessions')}</option>
          {sessions.map(session => <option key={session.id} value={session.id}>{session.name}</option>)}
        </FilterSelect>
        <FilterSelect value={filters.moduleId} onChange={text('moduleId')} aria-label={t('questions.module')}>
          <option value="">{t('questions.chooseModule')}</option>
          {modules.map(module => <option key={module.id} value={module.id}>{module.title}</option>)}
        </FilterSelect>
        <FilterSelect value={filters.groupId} onChange={text('groupId')} aria-label={t('common.groups')}>
          <option value="">{t('groups.all')}</option>
          {groups.map(group => <option key={group.id} value={group.id}>{group.name}</option>)}
        </FilterSelect>
        <Input type="date" className="h-9 w-auto" value={filters.from} onChange={text('from')} aria-label={t('questions.from')} />
        <Input type="date" className="h-9 w-auto" value={filters.to} onChange={text('to')} aria-label={t('questions.to')} />
      </TableToolbar>
    </div>
  )
}

export default QuestionFiltersBar
